export const clientsConstants = {
  GET_CLIENTS_REQUEST: "GET_CLIENTS_REQUEST",
  GET_CLIENTS_SUCCESS: "GET_CLIENTS_SUCCESS",
  GET_CLIENTS_FAILURE: "GET_CLIENTS_FAILURE",
  GET_CLIENTS_RESET: "GET_CLIENTS_RESET",

  VIEW_CLIENT_REQUEST: "VIEW_CLIENT_REQUEST",
  VIEW_CLIENT_SUCCESS: "VIEW_CLIENT_SUCCESS",
  VIEW_CLIENT_FAILURE: "VIEW_CLIENT_FAILURE",
  VIEW_CLIENT_RESET: "VIEW_CLIENT_RESET",

  ADD_CLIENT_REQUEST: "ADD_CLIENT_REQUEST",
  ADD_CLIENT_SUCCESS: "ADD_CLIENT_SUCCESS",
  ADD_CLIENT_FAILURE: "ADD_CLIENT_FAILURE",
  ADD_CLIENT_RESET: "ADD_CLIENT_RESET",

  EDIT_CLIENT_REQUEST: "EDIT_CLIENT_REQUEST",
  EDIT_CLIENT_SUCCESS: "EDIT_CLIENT_SUCCESS",
  EDIT_CLIENT_FAILURE: "EDIT_CLIENT_FAILURE",
};
